<template>
  <div>
    <div class="row align-items-center mb-2">
      <div class="col">
        <span class="text-muted">userOnline:</span>
        {{ userOnline }}
      </div>
    </div>

    <vue-data-table
      :headers="headers"
      :data="tableUsers"
      :items-per-page="25"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :table-actions="tableActions"
      :show-filter="false"
      :sync-with-url="false"
    >
      <template #cell-lastSeenText="{ row }">
        <span
          class="p-0 m-0 d-inline-block me-1"
          style="font-size: 40px; line-height: 0.3; font-weight: bolder"
          :class="
            row.last_seen_minutes_ago != null &&
            row.last_seen_minutes_ago < 30 &&
            row.last_seen_seconds_ago != -1
              ? 'text-success'
              : 'text-secondary'
          "
        >
          .
        </span>
        <span
          v-if="row.last_seen_seconds_ago == -1"
          class="text-secondary"
        >
          Inactif
        </span>
        <span
          v-else-if="row.last_seen_seconds_ago == 0"
          class="text-success"
        >
          Actif maintenant
        </span>
        <span
          v-else-if="row.last_seen_seconds_ago < 60"
          class="text-success"
        >
          active il y a {{ row.last_seen_seconds_ago }} secondes
        </span>
        <span
          v-else-if="row.last_seen_minutes_ago < 60"
          :class="
            row.last_seen_minutes_ago < 30
              ? 'text-success'
              : 'text-secondary'
          "
        >
          active il y a {{ row.last_seen_minutes_ago }} minutes
        </span>
        <span
          v-else-if="row.last_seen_hours_ago < 24"
          class="text-secondary"
        >
          active il y a {{ row.last_seen_hours_ago }} heures
        </span>
        <span v-else class="text-secondary">
          active il y a {{ row.last_seen_days_ago }} jours
        </span>
      </template>

      <template #cell-access="{ row }">
        <span
          v-if="row.access"
          class="bg-success rounded px-2 py-1 text-white"
        >
          Autorisé
        </span>
        <span
          v-else
          class="bg-danger rounded px-2 py-1 text-white"
        >
          Bloqué
        </span>
      </template>

      <template #cell-created_at="{ row }">
        <span v-if="row.created_at" class="text-muted small">
          {{ formatDate(row.created_at) }}
        </span>
        <span v-else class="text-muted">—</span>
      </template>

      <template #cell-userFullName="{ row }">
        <span class="text-muted small">{{ row.name || "—" }}</span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: "reference", label: "Référence Nº", class: "" },
        { field: "employeeName", label: "Nom", class: "" },
        { field: "username", label: "Nom d'utilisateur", class: "" },
        { field: "roleName", label: "Rôle", class: "" },
        { field: "lastSeenText", label: "Vu récemment", class: "" },
        { field: "access", label: "Accès", class: "" },
      ],
      summableColumns: [],
      buttons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil-square",
          class: "btn btn-outline-secondary",
          action: (user) => {
            this.$router.push({
              name: "users-edit",
              params: { reference: user.reference },
            });
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-outline-danger",
          action: (user) => this.remove(user),
        },
      ],
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Créer un nouvel utilisateur",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => this.$router.push({ name: "users-create" }),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("user", {
      users: "getAll",
      userOnline: "getUserOnline",
    }),
    tableUsers() {
      const list = this.users || [];
      return list.map((u) => ({
        ...u,
        employeeName:
          u.employee && u.employee.fullName ? u.employee.fullName : "",
        roleName: u.role && u.role.fullName ? u.role.fullName : "",
        lastSeenText: this.buildLastSeenText(u),
      }));
    },
  },
  mounted() {
    this.$store.dispatch("user/getAll");
    this.$store.dispatch("user/fetchUserStatus");
  },
  methods: {
    formatDate(value) {
      try {
        return new Date(value).toLocaleDateString("fr-FR");
      } catch (e) {
        return "—";
      }
    },
    buildLastSeenText(u) {
      const sec = u.last_seen_seconds_ago;
      const min = u.last_seen_minutes_ago;
      const hrs = u.last_seen_hours_ago;
      const days = u.last_seen_days_ago;
      if (sec === -1) return "Inactif";
      if (sec == null) return "—";
      if (sec === 0) return "Actif maintenant";
      if (sec < 60) return "active il y a " + sec + " secondes";
      if (min != null && min < 60) {
        return "active il y a " + min + " minutes";
      }
      if (hrs != null && hrs < 24) {
        return "active il y a " + hrs + " heures";
      }
      if (days != null) return "active il y a " + days + " jours";
      return "—";
    },
    async refresh() {
      await this.$store.dispatch("user/getAll");
      await this.$store.dispatch("user/fetchUserStatus");
    },
    async remove(data) {
      const user = data;
      const label = user.name || user.employeeName || user.username || "";
      await this.$confirm({
        message: "Vous voulez supprimer l'utilisateur " + label,
        button: {
          no: "Non",
          yes: "Oui",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("user/destroy", user.reference);
          }
        },
      });
    },
  },
};
</script>
